import styled from 'styled-components';

export const Container = styled.div`
	top: 50%;
	left: 50%;
	position: absolute;
	transform: translate(-50%, -50%);
`;
